export default __webpack_public_path__ + "static/media/withdrawal-alpha.19cb5e75.svg";